import React from "react";
import "./TileMetric.css";

interface TileMetricProps {
  title: string;
  value: string;
  text: string;
  icon?: React.ReactNode;
  color?: string;
}

const TileMetric: React.FC<TileMetricProps> = ({
  title,
  value,
  text,
  icon,
  color,
}) => {
  return (
    <div className="tile-metric">
      <h3>{title}</h3>
      <div className="tile-metric-value-container">
        {icon && (
          <div
            className="tile-metric-icon"
            style={color ? { color } : undefined}
          >
            {icon}
          </div>
        )}
        <h2 style={color ? { color } : undefined}>{value}</h2>
      </div>
      <p>{text}</p>
    </div>
  );
};

export default TileMetric;
export type { TileMetricProps };
